module.exports = __webpack_public_path__ + "img/chevronDown.d4c8a03c.svg";